// src/utils/api.js

const BASE_URL = '/api';

function getToken() {
  return localStorage.getItem('coastal_token');
}

async function request(method, path, body = null) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const opts = { method, headers };
  if (body) opts.body = JSON.stringify(body);

  const res = await fetch(`${BASE_URL}${path}`, opts);

  if (res.status === 401) {
    localStorage.removeItem('coastal_token');
    window.location.href = '/login';
    return;
  }

  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Request failed');
  return json.data ?? json;
}

export const api = {
  get:    (path)         => request('GET',    path),
  post:   (path, body)   => request('POST',   path, body),
  put:    (path, body)   => request('PUT',    path, body),
  delete: (path)         => request('DELETE', path),
};

export default api;
